// extracted by mini-css-extract-plugin
export default {"p":"_8fc5b09741 eb75fde6bc _4d38b10b2b","clr":"e3b081add4","dls":"_7b9713a719"};